import React from 'react';
import { VStack, Skeleton, Text, Box } from '@chakra-ui/react';
import ItemPergunta from './ItemPergunta';

const ListaPerguntas = ({ perguntas, isLoading, onResponder, onAbrirRespostasProntas, submittingId, answeredIds, onExcluir, deletingId }) => {
    if (isLoading && (!perguntas || perguntas.length === 0)) {
        return (
            <VStack spacing={4} mt={8} align="stretch">
                <Skeleton height="180px" borderRadius="lg" />
                <Skeleton height="180px" borderRadius="lg" />
                <Skeleton height="180px" borderRadius="lg" />
            </VStack>
        );
    }

    if (!isLoading && (!perguntas || perguntas.length === 0)) {
        return (
            <Box textAlign="center" p={10} bg="gray.50" borderRadius="md" mt={8}>
                <Text>Nenhuma pergunta encontrada para os filtros selecionados.</Text>
            </Box>
        );
    }

    return (
        <VStack spacing={4} mt={8} align="stretch">
            {perguntas.map((pergunta) => (
                <ItemPergunta
                    key={pergunta.id}
                    pergunta={pergunta}
                    onResponder={onResponder}
                    onAbrirRespostasProntas={onAbrirRespostasProntas}
                    isSubmitting={submittingId === pergunta.id}
                    isRemoving={answeredIds.includes(pergunta.id)}
                    onExcluir={onExcluir}
                    deletingId={deletingId}
                />
            ))}
        </VStack>
    );
};

export default ListaPerguntas;